"use client";

import { useEffect } from "react";
import { installSupplierPerfConsoleHelpers } from "./supplierPerfDiagnostics";
import SupplierPerfDebugOverlay from "./SupplierPerfDebugOverlay";

/** Mounts dev-only perf helpers once inside supplier portal shell. */
export default function SupplierPerfBootstrap() {
  useEffect(() => {
    installSupplierPerfConsoleHelpers();
  }, []);

  return <SupplierPerfDebugOverlay />;
}
